import { createFeatureSelector, createSelector } from '@ngrx/store';
import { WorkflowsState } from './workflows.reducers';

export const selectWorkflowsState = createFeatureSelector<WorkflowsState>('workflows');

export const selectWorkflowRules = createSelector(selectWorkflowsState, (s) => s.rules);

export const selectWorkflowsLoading = createSelector(selectWorkflowsState, (s) => s.loading);

export const selectWorkflowsLoadError = createSelector(selectWorkflowsState, (s) => s.loadError);

export const selectWorkflowSchema = createSelector(selectWorkflowsState, (s) => s.schema);

export const selectWorkflowSchemaLoading = createSelector(
  selectWorkflowsState,
  (s) => s.schemaLoading
);

export const selectWorkflowTemplates = createSelector(selectWorkflowsState, (s) => s.templates);

export const selectWorkflowTemplatesLoading = createSelector(
  selectWorkflowsState,
  (s) => s.templatesLoading
);

export const selectWorkflowSaveLoading = createSelector(
  selectWorkflowsState,
  (s) => s.saveLoading
);

export const selectWorkflowSaveError = createSelector(
  selectWorkflowsState,
  (s) => s.saveError
);

export const selectWorkflowSaveCompletedAt = createSelector(
  selectWorkflowsState,
  (s) => s.saveCompletedAt
);
